import React from "react"
import { Parallax } from "react-scroll-parallax"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import Nav from "../../components/nav"

import SparklePaymentIllustration from "../../images/sparkle-pay-illustration.svg"
import SendPaymentIllustration from "../../images/sparklepay-logs.svg"
import SendPaymentPageImage from "../../images/sparkle-payment-page.png"

const sparklepay = () => {
  return (
    <Layout>
      <Seo
        title="SparklePay - Receive that payment surprise into your account"
        desc="SparklePay is an innovative means of sending and receive payments with the use of a uniquely generated payment link."
      />
      <div className="sparklepay__hero">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>

        <div className="container">
          <div className="row align-center py-5">
            <div className="col-lg-6">
              <h1 className="mt-5 pt-lg-5 pt-4 sparkle-deep-blue">
                SparklePay
              </h1>
              <div className="description--wrapper">
                <p className="mt-4 hero-paragraph">
                  Tired of the old-school hassle of typing a 10-digit account
                  number for a simple money transfer? Say hello to SparklePay!​
                </p>
              </div>
            </div>
            <div className="col-lg-6 order-first order-lg-last">
              <img
                loading="lazy"
                src={SparklePaymentIllustration}
                className="img-fluid banner--tribe-image position-relative mt-5"
                alt="SparklePay is an innovative means of sending and receive payments"
                title="SparklePay is an innovative means of sending and receive payments"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="payment position-relative">
        <div className="container my-lg-5 py-lg-5">
          <div className="row align-center">
            <div className="col-lg-6 my-3">
              <h4 className="sparkle--title sparkle-deep-blue pt-lg-0 pt-4">
                Why waste time typing a 10-digit account number?​
              </h4>
              <div className="description--wrapper">
                <p className="sparkle--paragraph">
                  Send your friends some sparkle without the use of an account
                  number. Just create a special link housing the amount you want
                  to send and add an interesting message to it - e.g., Chop my
                  money! 😉- making your transactions simple, personal and fun!
                  ​ and more fun.
                </p>
              </div>
            </div>

            <div className="col-lg-5 position-relative offset-lg-1 order-first order-lg-last">
              <Parallax y={[20, 0]}>
                <img
                  src={SendPaymentIllustration}
                  className="img-fluid position-relative"
                  alt="Manage your Business accounting, store keeping & payment request"
                  title="Manage your Business accounting, store keeping & payment request"
                  data-aos="reveal-image"
                  data-aos-duration="4000"
                />
              </Parallax>
            </div>
          </div>
        </div>

        <div className="position-relative my-lg-5 py-lg-5">
          <div className="container ">
            <div className="row justify-content-center">
              <div className="col-lg-9 pt-lg-5 text-center">
                <img
                  src={SendPaymentPageImage}
                  className="img-fluid position-relative d-lg-none"
                  alt="With Sparkle it is more than just banking, it is improving  your financial lifestyle"
                  title="With Sparkle it is more than just banking, it is improving  your financial lifestyle"
                  style={{ zIndex: 5 }}
                  loading="lazy"
                />

                <h4 className="line-height sparkle-deep-blue sparkle--mont__900 sparkle--font__36">
                  Make secure payments​
                  <br /> in a breeze.
                </h4>
                <p className="sparkle--color__light sparkle--font__18 my-4 pb-5 body-paragraph">
                  When you create the link, the money is deducted from your
                  account until the payment is accepted by the receiver. ​ If
                  your friend has the Sparkle app, it automatically opens and in
                  just a single tap, the money is all theirs. No Sparkle app? No
                  problem. A browser page opens for them to receive the payment
                  in any bank account of their choosing.​
                </p>

                <img
                  src={SendPaymentPageImage}
                  loading="lazy"
                  className="img-fluid position-relative d-none d-lg-block"
                  alt="Once you generate the link, the funds is taken from your
                  account and awaits the intended account to be disbursed into"
                  title="Once you generate the link, the funds is taken from your
                  account and awaits the intended account to be disbursed into"
                  style={{ zIndex: 5 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default sparklepay
